module.exports = __webpack_public_path__ + "img/slide05_m.10d63ab6.jpg";